import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../hooks/useNotification';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useTranslation } from "react-i18next";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useForm } from '../../../hooks/useForm';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { fetchServiceById, fetchByCode, getCompanies, insertDataService, updateService } from '../../../services/service.service';
import { CreateFormService } from '../components/CreateFormService';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import useResolveCompanyInfo from '../../../hooks/useResolveCompanyInfo';
import useCompanies from '../../../hooks/useCompanies';
import { useCompanyConfiguration } from '../../../hooks/useCompanyConfiguration';
import { ensureArray } from '../../../utils/validateResponseApi';
import useManageProductService from '../hooks/useManageProductService';

export const LayoutServices = () => {
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const {
        companyViewActive,
        id_company,
        id_user_action
    } = useResolveCompanyInfo();

    const {
        companies,
        fetchCompanies,
    } = useCompanies();

    const {
        selectedCompanyId,
        changeCompany
    } = useCompanyConfiguration();

    const {
        configuration,
        taxesSiigo,
        activeCompanyId
    } = useManageProductService();

    const initialState = {
        id_company: '',
        type: 'Producto',
        name: '',
        description: '',
        category: '',
        line: '',
        subline: '',
        ans: '',
        code_sku: '',
        unit_code: '',
        unit_description: '',
        brand: '',
        reference: '',
        account_tax_iva: '',
        account_discount: '',
        account_tax_others: ''
    }

    const [values, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(initialState);
    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    // const [companies, setCompanies] = useState([]);

    const [id, setId] = useState(null);
    const formService = useRef();

    const fetchDataService = useCallback(async (id) => {
        setIsEdit(true);
        setLoading(true);
        try {
            const response = await fetchServiceById(userSession.token, id);
            if (response.status === 200) {
                setAllInfo(response.data);
            }
        } catch (error) {
            console.error("Error fetching service data:", error);
        } finally {
            setLoading(false);
        }
    }, [setAllInfo, userSession.token])

    const getInfo = async () => {
        const rawData = await fetchCompanies(id_user_action);
        const dataArray = ensureArray(rawData);
        if (dataArray.length === 1) {
            handleDirectInputChange("id_company", dataArray[0].id_company);
            setOpenDialogCompany(false);
        }
        else {
            const dto = dataArray.find(p => p.id_company === selectedCompanyId);
            if (dto) {
                handleDirectInputChange("id_company", dto.id_company);
                return;
            }
            setOpenDialogCompany(true);
        }
    }

    useEffect(() => {
        if (location.state?.config) {
            const { config } = location.state;
            if (config.data?.id) {
                setId(config.data?.id);
                fetchDataService(config.data?.id);
                setIsEdit(true);
            } else {
                if (companyViewActive)
                    handleDirectInputChange("id_company", id_company);
                else {
                    getInfo();
                }
            }
        }
    }, [location.state]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const isValidFormService = formService.current?.validForm();
        if (isValidFormService) {
            if (isEdit) {
                updateService(JSON.stringify({ ...values, id_product_service: id }), userSession.token);
                sendNotification({ msg: t('messages.actionUpdatedSuccess', { action: values.type }), variant: "success" });
            } else {
                insertDataService(JSON.stringify(values), userSession.token);
                sendNotification({ msg: t('messages.actionCreatedSuccess', { action: values.type }), variant: "success" });
            }
            Cancel();
        }
        else
            sendNotification({ msg: t('validation.requiredFieldsMissing'), variant: "error" });
    };

    const Cancel = () => navigate(-1);

    const handleConfirmAction = useCallback(async (dto) => {
        changeCompany(dto.id_company);
        handleDirectInputChange("id_company", dto.id_company)
        setOpenDialogCompany(false);
    }, [changeCompany, handleDirectInputChange]);

    const handleSearchProduct = async (event) => {
        const { value } = event.target;
        if (value && value.length > 3) {
            try {
                const response = await fetchByCode(userSession.token, { code_sku: values.code_sku, id_company });
                if (response.status === 200 && response.data) {
                    handleDirectInputChange('code_sku', '')
                    sendNotification({ msg: t('validation.productsExisting'), variant: "error" });
                }
            } catch (error) {
                console.error("Error fetching service data:", error);
            }
        }
    };

    return (
        <Box sx={{ width: '90%', mx: 'auto' }}>
            <Typography variant="h4" gutterBottom>
                {t('productsAndServices.title')}
            </Typography>

            <Card sx={{ mb: 3 }}>
                <CardContent >
                    <CreateFormService
                        ref={formService}
                        dto={values}
                        configuration={configuration}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        handleSearchProduct={handleSearchProduct}
                        isEdit={isEdit}
                        taxesSiigo={taxesSiigo}
                    />

                    <ActionButtons
                        onCancel={Cancel}
                        onSubmit={handleSubmit}
                        submitLabel={t('save')}
                    // disabledSubmit={isView}
                    />
                </CardContent>
            </Card>
            <DialogSelectCompany
                openDialogConfirm={openDialogCompany}
                handleCancelConfirm={Cancel}
                handleConfirmAction={handleConfirmAction}
                data={companies}
            />
            <LoadingOverlay isOpen={loading} />
        </Box>
    );
};